import React from "react";

export default function Icon() {
  return (
    <svg
      width="45"
      height="20"
      viewBox="0 0 45 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.8784 19.3212C10.6789 19.3212 13.2215 16.8321 13.2215 13.2457V13.1654C13.2215 9.92693 10.9733 8.42814 8.56455 7.94638L12.9539 3.34294V0.265052H1.68615V3.71764H8.18985L4.06816 8.29432L4.52315 10.7566H5.64725C8.05603 10.7566 9.39424 11.6934 9.39424 13.2992V13.3528C9.39424 14.8515 8.29691 15.7883 6.79811 15.7883C5.13873 15.7883 3.98787 14.9854 3.02436 13.9683L0.695869 16.6983C2.14114 18.2506 4.14845 19.3212 6.8784 19.3212ZM23.6874 19H27.3541V15.146H29.629V11.9075H27.3541V0.157995H23.955L15.1496 12.3357L15.6313 15.146H23.6874V19ZM19.4051 11.9075L23.6874 5.85877V11.9075H19.4051ZM37.4318 19.3212C41.3126 19.3212 44.0158 16.8589 44.0158 12.871V12.7907C44.0158 8.58872 41.2591 6.87581 38.0742 6.87581C37.191 6.87581 36.6021 6.98287 35.9866 7.14345L36.2007 3.7444H43.2397V0.265052H32.989L32.4537 9.47194L34.6216 10.8904C35.3442 10.5693 36.2274 10.3016 37.191 10.3016C38.9306 10.3016 40.2153 11.2919 40.2153 12.9513V12.9781C40.2153 14.691 39.0912 15.7348 37.3515 15.7348C35.933 15.7348 34.8089 15.0924 33.6046 14.0486L31.4367 16.9392C33.0425 18.438 35.0231 19.3212 37.4318 19.3212Z"
        fill="#231D2C"
      />
    </svg>
  );
}
